import React from "react";
import { CButton, CButtonGroup } from "@coreui/react";

function Buttons({ onEdit, onRemove }) {
  return (
    <>
      <CButtonGroup size="sm">
        <CButton onClick={onEdit} color="info">
          Editar
        </CButton>
        <CButton onClick={onRemove} color="danger">
          Remover
        </CButton>
      </CButtonGroup>
    </>
  );
}

export default Buttons;
